import styled from 'styled-components';
export const ModalWrapper = styled.div`
  height: 100%;
  .Dropdown-root {
    position: relative;
    // margin-top: 7px;
  }
  .Dropdown-control {
    position: relative;
    overflow: hidden;
    background-color: var(--main-bg-primary-alt);;
    border: 1px solid var(--main-bg-primary-alt);
    border-radius: 2px;
    box-sizing: border-box;
    color: var(--main-text-primary);
    font-family: var(--fontRegular);
    font-size: 12.1px;
    line-height: 15px;
    cursor: default;
    outline: none;
    transition: all 200ms ease;
    height: 36px;
    svg {
      //margin-top: -4px;
    }
  }

  .Dropdown-arrow {
    border-color: #999 transparent transparent;
    border-style: solid;
    border-width: 5px 5px 0;
    content: ' ';
    display: block;
    height: 0;
    margin-top: -ceil(2.5);
    position: absolute;
    right: 10px;
    top: 14px;
    width: 0;
  }
  .is-open .Dropdown-arrow {
    border-color: transparent transparent #999;
    border-width: 0 5px 5px;
  }

  .Dropdown-menu {
    background-color: var(--main-bg-primary-alt);
    box-shadow: var(--dropdownBoxShadow);
    border-radius: var(--dropdownBorderRadius);
    border: 0px solid #ccc;
    box-sizing: border-box;
    margin-top: -1px;
    max-height: 150px;
    overflow-y: auto;
    position: absolute;
    top: 100%;
    width: 100%;
    z-index: 1000;
    -webkit-overflow-scrolling: touch;
  }

  .Dropdown-menu .Dropdown-group > .Dropdown-title {
    padding: 8px 10px;
    color: rgba(51, 51, 51, 1);
    font-family: var(--fontRegular);
    text-transform: capitalize;
  }

  .Dropdown-option {
    box-sizing: border-box;
    background-color: var(--main-bg-primary);
    color: var(--main-text-primary);
    cursor: pointer;
    display: block;
    padding: 8px 20px;
    font-size: 14px;
  }

  .Dropdown-option:last-child {
    border-bottom-right-radius: 2px;
    border-bottom-left-radius: 2px;
    border-bottom: none;
  }

  .Dropdown-option:hover {
    color: var(--brand-text-primary);
    background: var(--dropdownItemHover);
    svg {
      color: var(--main-text-primary);
    }
  }

  .Dropdown-option.is-selected {
    color: var(--brand-text-primary);
    background-color: var(--main-bg-primary);
    &:hover {
      background: var(--main-bg-secondary);
    }
    svg {
      color: var(--main-text-primary);
    }
  }

  .Dropdown-noresults {
    box-sizing: border-box;
    color: var(--main-text-secondary);
    cursor: default;
    display: block;
    padding: 8px 10px;
    font-size: 14px;
  }
`;
